/**
 * Reusable scroll indicator component
 * Creates an animated arrow that indicates the user should scroll down
 */

import { assetUrl } from './pathResolver'

let globalScrollIndicator: HTMLElement | null = null

export function createScrollIndicator(): HTMLElement {
  const indicator = document.createElement('img')
  indicator.className = 'scroll-indicator scroll-indicator--fixed'
  indicator.src = assetUrl('/assets/images/arrow-down.svg')
  indicator.alt = ''
  indicator.style.opacity = '0'
  indicator.style.visibility = 'hidden'
  return indicator
}

export function showScrollIndicator(indicator: HTMLElement): void {
  indicator.style.opacity = '1'
  indicator.style.visibility = 'visible'
}

export function hideScrollIndicator(indicator: HTMLElement): void {
  indicator.style.opacity = '0'
  indicator.style.visibility = 'hidden'
}

/**
 * Get or create the global scroll indicator
 */
export function getGlobalScrollIndicator(): HTMLElement {
  if (!globalScrollIndicator) {
    globalScrollIndicator = createScrollIndicator()
    document.body.appendChild(globalScrollIndicator)
  }
  return globalScrollIndicator
}

/**
 * Show global scroll indicator
 */
export function showGlobalScrollIndicator(): void {
  const indicator = getGlobalScrollIndicator()
  showScrollIndicator(indicator)
}

/**
 * Hide global scroll indicator
 */
export function hideGlobalScrollIndicator(): void {
  if (globalScrollIndicator) {
    hideScrollIndicator(globalScrollIndicator)
  }
}
